export const ADMIN_COMPANY = 'admin,company,festival';
export const PAGINATION_LIMIT_1000 = { limit: 1000 };
export const PAGINATION_LIMIT_ZERO = { limit: 0 };
export const FIRST_PAGE = 1;
